import { addDestroyableEventListener } from '../../dom';
// eslint-disable-next-line @typescript-eslint/naming-convention
export function AgContextualMenuHeader(base) {
    return class extends base {
        constructor() {
            super(...arguments);
            this.destroyFunctions = [];
        }
        init(params) {
            super.init(params);
            this.getGui().classList.add('ag-header-contextual-menu');
            this.setupMenu(params);
        }
        destroy() {
            if (Boolean(this.destroyFunctions)) {
                this.destroyFunctions.forEach((fnc) => fnc());
            }
        }
        setupMenu(params) {
            const showMenuHandler = this.showMenu.bind(this, params);
            this.destroyFunctions.push(addDestroyableEventListener(this.getGui(), 'contextmenu', showMenuHandler));
        }
        showMenu(params, event) {
            event.preventDefault();
            params.showColumnMenu(this.getGui());
        }
    };
}
